import axios from "axios";

export default function getPurchaseOrderNotification() {
  return new Promise((resolve, reject) => {
    axios
      .get("/distributor/admin/api/v1/purchase-order/notification-count")
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
